import { FC, PropsWithChildren } from 'react';

type Props = {
	className?: string;
};

const LuxembourgFlagIcon: FC<PropsWithChildren<Props>> = ({ className }) => {
	return (
		<svg
			width='20'
			height='14'
			viewBox='0 0 20 14'
			fill='none'
			xmlns='http://www.w3.org/2000/svg'
			className={`${className}`}>
			<rect
				x='0.25'
				y='0.25'
				width='19.5'
				height='13.5'
				rx='1.75'
				fill='white'
				stroke='#F5F5F5'
				strokeWidth='0.5'
			/>
			<mask
				id='mask0_2332_15422'
				style={{ maskType: 'luminance' }}
				maskUnits='userSpaceOnUse'
				x='0'
				y='0'
				width='20'
				height='14'>
				<rect
					x='0.25'
					y='0.25'
					width='19.5'
					height='13.5'
					rx='1.75'
					fill='white'
					stroke='white'
					strokeWidth='0.5'
				/>
			</mask>
			<g mask='url(#mask0_2332_15422)'>
				<path
					fillRule='evenodd'
					clipRule='evenodd'
					d='M0 4.66667H20V0H0V4.66667Z'
					fill='#F14455'
				/>
				<path
					fillRule='evenodd'
					clipRule='evenodd'
					d='M0 14H20V9.33337H0V14Z'
					fill='#29B4EE'
				/>
			</g>
		</svg>
	);
};

export default LuxembourgFlagIcon;
